import { Routes } from '@angular/router';
import { CONSTANTS } from '@cue-admin/constants';
import { AccountExistsGuard, LicenseExistGuard, UserIsLoggedInGuard, UserRoleGuard } from '@cue-admin/account-data';
import { LayoutComponent } from './components';

export const layoutRoutes: Routes = [
  {
    path: '',
    canActivate: [AccountExistsGuard, UserIsLoggedInGuard, LicenseExistGuard, UserRoleGuard],
    canActivateChild: [UserRoleGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: CONSTANTS.paths.dashboard,
        pathMatch: 'full',
      },
      {
        path: CONSTANTS.paths.notFound,
        loadChildren: () => import('@cue-admin/not-found-pages').then((x: any) => x.notFoundRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.analyticsTemplate,
        loadChildren: () => import('@cue-admin/analytics-template-pages').then((x: any) => x.analyticsTemplateRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.areas,
        loadChildren: () => import('@cue-admin/areas-pages').then((x: any) => x.areasRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.connectionAgents,
        loadChildren: () => import('@cue-admin/connection-agent-pages').then((x: any) => x.connectionAgentRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.languages,
        loadChildren: () => import('@cue-admin/languages-pages').then((x: any) => x.languagesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.log,
        loadChildren: () => import('@cue-admin/log-pages').then((x: any) => x.logRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.security,
        loadChildren: () => import('@cue-admin/security-pages').then((x: any) => x.securityRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.properties,
        loadChildren: () => import('@cue-admin/properties-pages').then((x: any) => x.propertiesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.resources,
        loadChildren: () => import('@cue-admin/resources-pages').then((x: any) => x.resourcesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.resourceProperties,
        loadChildren: () => import('@cue-admin/resource-properties-pages').then((x: any) => x.resourcePropertiesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.sensor,
        loadChildren: () => import('@cue-admin/sensor-pages').then((x: any) => x.sensorRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.support,
        loadChildren: () => import('@cue-admin/support-pages').then((x: any) => x.supportRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.setup,
        loadChildren: () => import('@cue-admin/setup-pages').then((x: any) => x.setupRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.timetables,
        loadChildren: () => import('@cue-admin/timetables-pages').then((x: any) => x.timetablesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.timeSettings,
        loadChildren: () => import('@cue-admin/time-settings-pages').then((x: any) => x.timeSettingsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.units,
        loadChildren: () => import('@cue-admin/units-pages').then((x: any) => x.unitsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.users,
        loadChildren: () => import('@cue-admin/users-pages').then((x: any) => x.usersRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.about,
        loadChildren: () => import('@cue-admin/about-pages').then((x: any) => x.aboutRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.touchONEAssist,
        loadChildren: () => import('@cue-admin/touch-one-assist-pages').then((x: any) => x.touchONEAssistRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.addin,
        loadChildren: () => import('@cue-admin/addin-pages').then((x: any) => x.addinRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.licenses,
        loadChildren: () => import('@cue-admin/licenses-pages').then((x: any) => x.licensesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.resourceTypes,
        loadChildren: () => import('@cue-admin/resource-types-pages').then((x: any) => x.resourceTypesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.adminUsers,
        loadChildren: () => import('@cue-admin/admin-users-pages').then((x: any) => x.adminUsersRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.dashboard,
        loadChildren: () => import('@cue-admin/dashboard-pages').then((x: any) => x.dashboardRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.news,
        loadChildren: () => import('@cue-admin/news-pages').then((x: any) => x.newsRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.notifications,
        loadChildren: () => import('@cue-admin/notifications-pages').then((x: any) => x.notificationsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.integrations,
        loadChildren: () => import('@cue-admin/integrations-pages').then((x: any) => x.integrationsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.qrCodes,
        loadChildren: () => import('@cue-admin/qr-codes-pages').then((x: any) => x.qrCodesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.qrCategories,
        loadChildren: () => import('@cue-admin/qr-categories-pages').then((x: any) => x.qrCategoriesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.navigation,
        loadChildren: () => import('@cue-admin/navigation-pages').then((x: any) => x.navigationRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.accessDenied,
        loadChildren: () => import('@cue-admin/access-denied-pages').then((x: any) => x.accessDeniedRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.userGroups,
        loadChildren: () => import('@cue-admin/user-groups-pages').then((x: any) => x.groupsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.features,
        loadChildren: () => import('@cue-admin/features-pages').then((x: any) => x.featuresRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.debug,
        loadChildren: () => import('@cue-admin/debug-pages').then((x: any) => x.debugRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.eventsRemake,
        loadChildren: () => import('@cue-admin/calendar-sync-pages').then((x: any) => x.calendarSyncRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.calendar.main,
        loadChildren: () => import('@cue-admin/calendar-pages').then((x: any) => x.calendarRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.webApps.main,
        loadChildren: () => import('@cue-admin/web-apps-pages').then((x: any) => x.webAppRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.analytics,
        loadChildren: () => import('@cue-admin/analytics-pages').then((x: any) => x.analyticsRoutes),
        data: { roles: [CONSTANTS.code.adminRole, CONSTANTS.code.analyticsRole] },
      },
      {
        path: CONSTANTS.paths.imageTemplates,
        loadChildren: () => import('@cue-admin/image-templates-pages').then((x: any) => x.imageTemplatesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.cookies,
        loadChildren: () => import('@cue-admin/cookies-pages').then((x: any) => x.cookiesRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.design,
        loadChildren: () => import('@cue-admin/design-pages').then((x: any) => x.DesignRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.digitalSignage,
        loadChildren: () => import('@cue-admin/digital-signage-pages').then((x: any) => x.digitalSignageRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.paths,
        loadChildren: () => import('@cue-admin/paths-pages').then((x: any) => x.pathsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.projects,
        loadChildren: () => import('@cue-admin/projects-pages').then((x: any) => x.projectsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.unitGroups,
        loadChildren: () => import('@cue-admin/unit-groups-pages').then((x: any) => x.unitGroupsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.tags,
        loadChildren: () => import('@cue-admin/tags-pages').then((x: any) => x.tagsRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
      {
        path: CONSTANTS.paths.unitClients,
        loadChildren: () => import('@cue-admin/unit-client-pages').then((x: any) => x.unitClientRoutes),
        data: { roles: [CONSTANTS.code.adminRole] },
      },
    ],
  },
];
